<template lang="pug">
.vip-open-container(:class='{ "ios-app": iOSAPP }')
  common-header(
    title='省钱会员',
    ref='header',
    active-color='black',
    inactive-color='white',
    :left-black-when-active='true',
    :left-black-when-inactive='false'
  )
  .remind-title.flex-mid
    img.img-front(
      src='https://m.hellobike.com/resource/helloyun/15979/lcsjH90crf.png?x-oss-process=image/quality,q_80'
    )
    span.price {{ userProperty.propTotalAmount }}
    img.img-end(
      src='https://m.hellobike.com/resource/helloyun/15979/iv5q8jz5RA.png?x-oss-process=image/quality,q_80'
    )
  .body
    template(v-if='loading')
      open-loading
    template(v-else)
      .group(v-for='(item, index) in userProperty.groupList', :key='index')
        .module
          .title {{ item.groupName }}
            span(v-if='item.groupDesc') ({{ item.groupDesc }})
          .subtitle
            span 价值
            .price {{ item.groupAmount }}元
        template(v-if='item.isExclusive')
          .right-card
            coupon-item-open.bike(
              v-if='item.propList[0]',
              :info='item.propList[0]'
            )
            .or 或
            coupon-item-open.bike(
              v-if='item.propList[1]',
              :info='item.propList[1]'
            )
        template(v-else)
          .right-card
            .card-item(v-for='(coupon, index) in item.propList', :key='index')
              coupon-item-open(:info='coupon')
  .rule(@click='ruleHandler')
    span 会员规则
    .unit |
    span 会员协议
  .bottom(@click='bayCardHandler')
    .btn
      span {{ goodsInfo.price || "-" }}元/{{ goodsInfo.days }}天 立即开通
      span 仅购买1次，不自动续费
</template>

<script>
import CommonHeader from '@/components/common-header';
import { env } from '@hb/NBridge/lib/h5';
// import Cashier from '@hb/h5-cashier';
import Toast from '@/components/toast';
import {
  userGoodsPropertyList,
  vipGoodsInfo,
  buyVipGoods,
  tryTakeOrderStatus,
} from '@/api/vip';
import { getTokenAndLocation, getTokenAndKey, isH5 } from '@/utils';
import { getVipBiz } from '@/utils/vip';
import Loading from '@/components/loading';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import CouponItemOpen from './components/coupon-item-open';
import OpenLoading from './components/open-loading';

import { ORDER_STATUS, GROUP } from './consts';
import { commonGoLink, getSource, isPreRender } from '../../utils';

function couponMapper(isExclusive) {
  return (coupon) => {
    const {
      propName: title,
      propDesc: desc,
      propAmount: currentPrice,
      goodsPropGuid: id,
      propBusinessLine,
      propTag,
      propNum,
    } = coupon;
    return {
      corner: propTag ? '首单神券' : '',
      currentPrice,
      title,
      desc,
      id,
      isExclusive,
      num: propNum || 0,
      type: getVipBiz(propBusinessLine),
    };
  };
}

export default {
  components: {
    CommonHeader,
    CouponItemOpen,
    OpenLoading,
  },
  data() {
    return {
      iOSAPP: env.isIOS && env.isEasyBikeApp,
      userProperty: {},
      goodsInfo: {},
      loading: true,
      cashier: null,
      env: process.env.VUE_APP_ENV,
      loadingPay: false,
      orderTimer: 0,
      curloopIntervalSecond: 0,
    };
  },
  beforeRouteEnter(to, form, next) {
    UBT.moduleExpose({
      pageId: 'platform_PurchasePage',
      categoryId: 'platform',
      moduleId: 'platform_PurchaseNotes',
      contentId: 'platform_PurchaseNotes',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    UBT.moduleExpose({
      pageId: 'platform_PurchasePage',
      categoryId: 'platform',
      moduleId: 'platform_Agreement',
      contentId: 'platform_Agreement',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
  mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.init();
  },
  methods: {
    init() {
      window.addEventListener('scroll', this.handler);
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.handler);
      });

      this.getUserGoodsPropertyList();
      this.getVipGoodsInfo();
      // this.initCashier();
    },
    async getUserGoodsPropertyList() {
      const { token } = await getTokenAndKey();
      userGoodsPropertyList({ token })
        .then((v) => {
          if (v && v.data) {
            const { propTotalAmount, groupList } = v.data;
            const groupListMapper = (groupList || []).map((group) => {
              const {
                groupAmount,
                groupDesc,
                groupName,
                isExclusive,
                propList,
              } = group;

              return {
                groupAmount,
                groupDesc,
                groupName,
                isExclusive,
                propList: (propList || []).map(couponMapper(isExclusive)),
              };
            });
            this.userProperty = {
              propTotalAmount,
              groupList: groupListMapper,
            };
            this.loading = false;
          }
        })
        .catch(() => {
          this.userProperty = {};
        });
    },
    async getVipGoodsInfo() {
      const { token } = await getTokenAndKey();
      vipGoodsInfo({ token })
        .then((v) => {
          if (v && v.data) {
            this.goodsInfo = v.data;

            UBT.moduleExpose({
              pageId: 'platform_PurchasePage',
              categoryId: 'platform',
              moduleId: 'platform_ToPurchase',
              contentId: 'platform_ToPurchase',
              exposureTimes: 1,
              businessInfo: {
                adsource: getSource(),
                ExperienceGroup: (() => {
                  const { days } = this.goodsInfo;
                  if (days === GROUP.thirty) {
                    return 1;
                  }
                  if (days === GROUP.ninety) {
                    return 2;
                  }
                  return 3;
                })(),
              },
            });
          }
        })
        .catch(() => {});
    },
    // initCashier() {
    //   if (isH5()) {
    //     return;
    //   }
    //   const instance = new Cashier();
    //   this.cashier = instance;
    //   instance.setEnv(this.env); // 仅针对小程序端
    // },
    bayCardHandler() {
      // 限制频繁调用
      if (!this.loadingPay) {
        this.loadingPay = true;
        this.bayCard();
      }
    },
    async bayCard() {
      const { goodsInfo } = this;
      const { token, cityCode, adCode } = await getTokenAndLocation();

      const toPost = {
        cityCode,
        adCode,
        token,
        ...(goodsInfo || {}),
        goodsGuid: goodsInfo.goodsId,
      };

      buyVipGoods(toPost)
        .then((v) => {
          if (v && v.data) {
            const {
              payNo,
              businessScene,
              businessType,
              price,
              loopIntervalSecond,
              orderNo,
              loopTotalSecond,
            } = v.data;

            this.cashier.showCashier({
              guid: payNo,
              amount: price,
              businessType, // （1：单车，2：助力车，3:电动车直租，4：打车，5：顺风车，9：平台公共业务，10：换电，11：景区业务）
              businessScene,
              orderId: payNo,
              type: 1, // （1:待支付订单，2:零元订单）
              cityCode,
              adCode,
              sucFn: () => {
                Loading.show();
                this.loadingPay = false;
                // 查询订单状态
                this.searchStatus({
                  token,
                  orderNo,
                  loopIntervalSecond,
                  loopTotalSecond,
                });
              },
              failFn: (e) => {
                Toast.show(e && e.message ? e.message : '购买失败');
                this.loadingPay = false;
              },
            });
          }
        })
        .catch((e) => {
          this.loadingPay = false;
          Toast.showError(e);
        });
    },
    // 轮询付费会员状态
    async searchStatus({
      token,
      orderNo,
      loopIntervalSecond,
      loopTotalSecond,
    }) {
      const orderTimer = setTimeout(async () => {
        if (this.curloopIntervalSecond >= loopTotalSecond) {
          clearTimeout(orderTimer);
          return;
        }
        const { data, msg } = await tryTakeOrderStatus({ token, orderNo });
        if (data) {
          const { status } = data;
          // 清除定时器
          clearTimeout(orderTimer);
          // 订单交易中
          if (status === ORDER_STATUS.padding) {
            this.curloopIntervalSecond += 1;
            this.searchStatus({
              token,
              orderNo,
              loopIntervalSecond,
              loopTotalSecond,
            });
            return;
          }

          UBT.clickButton({
            pageId: 'platform_PurchasePage',
            buttonName: 'platform_ToPurchase',
            categoryId: 'platform',
            businessInfo: {
              adsource: getSource(),
              ExperienceGroup: (() => {
                if (this.goodsInfo.days === GROUP.thirty) {
                  return 1;
                }
                if (this.goodsInfo.days === GROUP.ninety) {
                  return 2;
                }
                return '';
              })(),
              TransactionResults: (() => {
                if (
                  status === ORDER_STATUS.fall
                  || status === ORDER_STATUS.closed
                ) {
                  return 0;
                }
                if (status === ORDER_STATUS.success) {
                  return 1;
                }
                return '';
              })(),
            },
          });

          // 订单成功
          if (status === ORDER_STATUS.success) {
            this.$router.replace('/vip');
          }
          // 订单失败
          if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
            Toast.show('正在支付中，请稍候查看');
            this.$router.go(-1);
          }
        } else {
          Toast.show(msg);
        }
        Loading.close();
      }, loopIntervalSecond * 1000);
    },
    ruleHandler() {
      UBT.clickButton({
        pageId: 'platform_PurchasePage',
        buttonName: 'platform_Agreement',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      commonGoLink('https://h.c3x.me/1hU19S', { isRuleLink: true });
    },
  },
};
</script>

<style lang="less" scoped>
.fontStyle(@lh: 0.36rem, @fs: 0.3rem, @fw: normal, @co: #fff) {
  line-height: @lh;
  font-size: @fs;
  font-weight: @fw;
  color: @co;
}

.vip-open-container {
  height: 100vh;
  padding-top: 0.9rem;
  background-image: url(https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/14d6cf12-c313-4fac-b533-94d2ef88a3cf.png);
  background-repeat: no-repeat;
  background-position-y: 0;
  background-size: 100%;
  background-color: #f0f3f5;

  .ios-app {
    padding-top: 0.44rem;
  }

  .back {
    width: 0.24rem;
    height: 0.24rem;
  }

  .remind-title {
    width: 100vw;
    height: 0.42rem;
    margin: 0.13rem 0 0.23rem;

    .img-front {
      max-width: 1.23rem;
      max-height: 0.42rem;
    }

    .price {
      height: 0.42rem;
      font-size: 0.34rem;
      font-weight: bolder;
      color: #fff;
      line-height: 0.36rem;
      text-shadow: 0 0 0 rgba(222, 43, 0, 0.51);
      position: relative;
      top: 0.01rem;
    }

    .img-end {
      max-width: 0.92rem;
      max-height: 0.42rem;
      position: relative;
      top: 0.01rem;
    }
  }

  .body {
    background: #fff;
    border-radius: 0.12rem;
    margin: 0 0.12rem;
    padding: 0 0.09rem 0.2rem;
    min-height: 3.45rem;

    .module {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 0.2rem;

      .title {
        .fontStyle(0.25rem, 0.18rem, bold, #242729);

        > span {
          font-size: 0.14rem;
          margin-left: 0.1rem;
          font-weight: 400;
        }
      }

      .subtitle {
        display: flex;
        .fontStyle(0.2rem, 0.14rem, 400, #000);

        .price {
          font-weight: bold;
          color: #d5261b;
        }
      }
    }

    .right-card {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .or {
        background: #d5261b;
        border-radius: 50%;
        padding: 0.03rem 0.06rem;
        margin: auto 0.15rem;
        .fontStyle(0.2rem, 0.14rem, 400, #fff);
      }

      .bike {
        width: 1.38rem;
        margin-top: 0.08rem;
      }

      .card-item {
        width: 0.76rem;
        margin-top: 0.08rem;

        &:not(:nth-child(4n + 4)) {
          margin-right: 0.095rem;
        }
      }
    }
  }

  .rule {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.19rem;
    padding-bottom: 1.17rem;

    > :last-child,
    > :first-child,
    .unit {
      .fontStyle(0.17rem, 0.12rem, 400, #879099);
    }

    .unit {
      padding: 0 0.04rem;
    }
  }

  .bottom {
    background: #fff;
    padding: 0.12rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;

    .btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #dd4c47;
      border-radius: 0.26rem;
      color: #fff;
      padding: 0.06rem 0;

      > :first-child {
        .fontStyle(0.25rem, 0.18rem, 500, #fff);
      }

      > :last-child {
        .fontStyle(0.16rem, 0.11rem, 400, #f7f9fa);
      }
    }
  }
}
</style>
